// material-ui
import { styled } from "@mui/material/styles";
import { CircularProgress } from "@mui/material/index";
// loader style
const LoaderWrapper = styled("div")(({ theme }) => ({
  // position: 'fixed',
  // top: 0,
  // left: 0,
  // zIndex: 2001,
  // width: '100%',
  // '& > * + *': {
  //   marginTop: theme.spacing(2)
  // }
}));

// ==============================|| Loader ||============================== //

const LoaderCircular = ({ size, color }) => (
  <LoaderWrapper>
    <CircularProgress
      color={color ? color : "primary"}
      size={size ? size : 48}
    />
  </LoaderWrapper>
);

export default LoaderCircular;
